import React from 'react'
import Img from 'gatsby-image'
import ReactPlayer from 'react-player/lazy'

const SplitOffset = ({ data }) => {
    const { fullWidthImage, leftContentGroup, rightContentGroup } = data

    let columnReverse = '';

    if (fullWidthImage) {
        columnReverse = 'column-reverse';
    }

    return (
        <section className="split-offset">
            {fullWidthImage && (
                <div className="full-image-wrapper">
                    <Img 
                        fluid={fullWidthImage?.localFile?.childImageSharp?.fluid}
                    />
                </div>
            )}
            <div className="offset-section">
                <div className="col left" style={{ flexDirection: columnReverse }}>
                    {leftContentGroup.media ? (
                        <div className="media-wrapper">
                            <ReactPlayer 
                                url={leftContentGroup.media}
                                className='react-player'
                                width='100%'
                                height='100%'
                                controls={true}
                            />
                        </div>    
                    ) : (
                        <div className="image-wrapper">
                            {leftContentGroup.image && (     
                                <Img 
                                    fluid={leftContentGroup.image?.localFile?.childImageSharp?.fluid}
                                />
                            )}
                        </div>
                    )}
                    <div className="content-wrapper">
                        {leftContentGroup.title && (
                            <h5>{leftContentGroup.title}</h5>
                        )}
                        <div dangerouslySetInnerHTML={{ __html: leftContentGroup.content }}></div>
                        {leftContentGroup.button && (
                            <a className="btn button-solid" href={leftContentGroup.button.url}>{leftContentGroup.button.title}</a>
                        )}
                    </div>
                </div>
                <div className="col right" style={{ flexDirection: columnReverse }}>
                    <div className="content-wrapper">
                        {rightContentGroup.title && (
                            <h5>{rightContentGroup.title}</h5>
                        )}
                        {rightContentGroup.content && (
                            <div dangerouslySetInnerHTML={{ __html: rightContentGroup.content }}></div>
                        )}
                    </div>   
                    <div className="image-wrapper">
                        {rightContentGroup.image && (
                            <Img 
                                fluid={rightContentGroup.image?.localFile?.childImageSharp?.fluid}
                            />
                        )}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SplitOffset
